import { takeLatest, call, put } from 'redux-saga/effects';
import {
  requestInProcess,
  requestFinished,
  updateList,
  sendRequest
} from '../../../../../../common/reducers/list/reducer';
import { timeoutCall } from '../../../../../../utils/sagaHalper';
import FaqContentsService from '../../../../services/FaqContentsService';

function* faqContentsMenuListSaga(reducerName) {
  yield put(requestInProcess(reducerName));
  let status = null;
  try {
    const result = yield call(timeoutCall, FaqContentsService.getMenu);
    if (result.response) {
      status = result.response.status;
      if (result.response.status) {
        yield put(
          updateList(reducerName, {
            itemsById: result.destructData.itemsById,
            itemsIds: result.destructData.itemsIds
          })
        );
      }
    }
  } catch (error) {
    console.log(error);
  }
  yield put(requestFinished(reducerName, status));
}

export default function createSaga(reducerName) {
  return [
    takeLatest(
      sendRequest(reducerName).type,
      faqContentsMenuListSaga,
      reducerName
    )
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/faqContents/reducers/static/lists/sagas/faqContentsMenuListSaga.js